import { forwardRef, Ref, type SVGProps } from 'react';

const SvgI8NIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 23 23"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M1.917 11.5h19.166m-19.166 0a9.583 9.583 0 0 0 9.583 9.583M1.917 11.5A9.583 9.583 0 0 1 11.5 1.917m9.583 9.583a9.583 9.583 0 0 1-9.583 9.583m9.583-9.583A9.583 9.583 0 0 0 11.5 1.917m0 0a14.66 14.66 0 0 1 3.833 9.583 14.66 14.66 0 0 1-3.833 9.583m0-19.166A14.66 14.66 0 0 0 7.667 11.5a14.66 14.66 0 0 0 3.833 9.583"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgI8NIcon);
export default ForwardRef;
